import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-admin/shared/api/axios";
import { SelectionDropdown } from "@libs/zapi-ui/custom";

type TUserSelectProps = {
  userId: string;
  setUserId: (project: string) => void;
};

export function UserSelect({ setUserId, userId }: TUserSelectProps) {
  const { data } = useQuery<{ id: string; label: string; value: string }[]>({
    queryKey: ["get-users"],
    queryFn: async () => {
      const response = await $api.get<{ id: number; firstName: string; lastName: string; email: string }[]>(
        "/admin/users"
      );
      return (
        response?.data?.map((i) => ({
          id: i.id + "",
          value: `${i.firstName} ${i.lastName} (${i.email})`,
          label: `${i.firstName} ${i.lastName} (${i.email})`
        })) || []
      );
    }
  });

  return (
    <div className="space-y-2 w-[258px]">
      <SelectionDropdown
        placeholder="Select User"
        options={[{ label: "All Users", value: "" }, ...(data || [])]}
        value={data?.find((i) => i.id === userId)?.value}
        onChange={(v) => {
          const vId = data?.find((i) => i.value === v)?.id || "";
          setUserId(vId);
          localStorage.setItem("user", vId);
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
